import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26eea491"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title is-size-4 has-text-centered mb-6" }, "Exploitation", -1))
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" SME and large companies involved "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please indicate SME and large companies involved in the consortium"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_7 = { class: "control" }
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Project outcomes "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please describe briefly expected project outcomes"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_11 = { class: "control" }
const _hoisted_12 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_13 = { class: "column" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" End users "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please indicate if any end-user/s involved in the consortium or support the project as external end-user"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_16 = { class: "control" }
const _hoisted_17 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createTextVNode(" Exploitation plan "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please select the mechanism of project results exploitation"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_20 = { class: "control" }
const _hoisted_21 = { class: "columns mb-0" }
const _hoisted_22 = { class: "column mb-0 pb-0" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Patents ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Publications ")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Licencing ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Other ")
const _hoisted_30 = { class: "column mb-0 pb-0" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Spin-off ")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Direct commercialization ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Joint Venture ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.sme) = $event)),
                  class: _normalizeClass(["input", { 'is-danger': _ctx.errors.sme }]),
                  type: "text"
                }, null, 2), [
                  [_vModelText, _ctx.data.sme]
                ])
              ]),
              (_ctx.errors.sme)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, "This field is required"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.outcomes) = $event)),
                  class: _normalizeClass(["input", { 'is-danger': _ctx.errors.outcomes }]),
                  type: "text"
                }, null, 2), [
                  [_vModelText, _ctx.data.outcomes]
                ])
              ]),
              (_ctx.errors.outcomes)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, "This field is required"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("p", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.endUsers) = $event)),
                  class: _normalizeClass(["input", { 'is-danger': _ctx.errors.endUsers }]),
                  type: "text"
                }, null, 2), [
                  [_vModelText, _ctx.data.endUsers]
                ])
              ]),
              (_ctx.errors.endUsers)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, "This field is required"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ep.patents) = $event)),
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.epChange && _ctx.epChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.ep.patents]
                      ]),
                      _hoisted_23
                    ]),
                    _hoisted_24,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ep.publications) = $event)),
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.epChange && _ctx.epChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.ep.publications]
                      ]),
                      _hoisted_25
                    ]),
                    _hoisted_26,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ep.licencing) = $event)),
                        onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.epChange && _ctx.epChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.ep.licencing]
                      ]),
                      _hoisted_27
                    ]),
                    _hoisted_28,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ep.other) = $event)),
                        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.epChange && _ctx.epChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.ep.other]
                      ]),
                      _hoisted_29
                    ]),
                    (_ctx.ep.other)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ep.otherText) = $event)),
                          class: "input",
                          onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.epChange && _ctx.epChange(...args))),
                          placeholder: "Please, describe here"
                        }, null, 544)), [
                          [_vModelText, _ctx.ep.otherText]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ep.spinOff) = $event)),
                        onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.epChange && _ctx.epChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.ep.spinOff]
                      ]),
                      _hoisted_31
                    ]),
                    _hoisted_32,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.ep.direct) = $event)),
                        onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.epChange && _ctx.epChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.ep.direct]
                      ]),
                      _hoisted_33
                    ]),
                    _hoisted_34,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.ep.joint) = $event)),
                        onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.epChange && _ctx.epChange(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.ep.joint]
                      ]),
                      _hoisted_35
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}